// Xorella Conditioner
import React from "react";
import { Col, Input, Row } from "reactstrap";
import { ColPrompt, InputRangeRow, ProgramNameRow, RadioButtonRow, RadioLabelCol, RunTimeRow } from "./index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";

export default function MachineXorella() {
   const { onChange } = useMachineSetupContextUpdater();
   const { machineSetup } = useMachineSetupContextState();
   return (
      <>
         <Row className="mb-2">
            <Col>
               <RunTimeRow ColPromptSizeProp={6} ColValueSizeProp={6} />
               <RunTimeRow
                  TitleProp="#1 Min"
                  ValueProp="minTime1"
                  ColPromptSizeProp={6}
                  ColValueSizeProp={6}
               />
               <InputRangeRow
                  titleProp={"#1 Mbar"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={0}
                  maxProp={999}
                  propertyNameProp={"mBar1"}
                  errorDialogueProp={"0-999 only"}
                  floatProp={false}
               />
               <InputRangeRow
                  titleProp={"#1 °C"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={0.0}
                  maxProp={99.9}
                  propertyNameProp={"celsius1"}
                  errorDialogueProp={"0.0-99.9 only"}
                  floatProp={true}
               />
               <InputRangeRow
                  titleProp={"#1 °C/min"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={0.0}
                  maxProp={9.9}
                  propertyNameProp={"celsiusMin1"}
                  errorDialogueProp={"0.0-9.9 only"}
                  floatProp={true}
               />
               <InputRangeRow
                  titleProp={"Yield Pounds"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={1}
                  maxProp={3300}
                  propertyNameProp={"pounds"}
                  errorDialogueProp={"1-3,300 only"}
                  floatProp={false}
               />
               <InputRangeRow
                  titleProp={"Std. Efficiency"}
                  descriptionProp={"%"}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={1}
                  maxProp={100}
                  propertyNameProp={"stdEfficiency"}
                  errorDialogueProp={"1-100 only"}
                  floatProp={false}
               />
            </Col>
            <Col>
               <InputRangeRow
                  titleProp={"Cycle Count"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={1}
                  maxProp={10}
                  propertyNameProp={"cycleCount"}
                  errorDialogueProp={"1-10 only"}
                  floatProp={false}
               />
               <RunTimeRow
                  TitleProp="#2 Min"
                  ValueProp="minTime2"
                  ColPromptSizeProp={6}
                  ColValueSizeProp={6}
               />
               <InputRangeRow
                  titleProp={"#2 Mbar"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={0}
                  maxProp={999}
                  propertyNameProp={"mBar2"}
                  errorDialogueProp={"0-999 only"}
                  floatProp={false}
               />
               <InputRangeRow
                  titleProp={"#2 °C"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={0.0}
                  maxProp={99.9}
                  propertyNameProp={"celsius2"}
                  errorDialogueProp={"0.0-99.9 only"}
                  floatProp={true}
               />
               <InputRangeRow
                  titleProp={"#2 °C/min"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={0.0}
                  maxProp={9.9}
                  propertyNameProp={"celsiusMin2"}
                  errorDialogueProp={"0.0-9.9 only"}
                  floatProp={true}
               />
               <RadioButtonRow
                  promptRowSizeProp={6}
                  valueRowSizeProp={6}
                  titleProp={"Labor Assignment"}
                  descriptionProp="%"
               >
                  <RadioLabelCol
                     groupNameProp={"laborPercentGroup"}
                     valueProp={25}
                     onChangeProp={"laborPct"}
                     displayProp={"25"}
                     stringProp
                  />
                  <RadioLabelCol
                     groupNameProp={"laborPercentGroup"}
                     valueProp={50}
                     onChangeProp={"laborPct"}
                     displayProp={"50"}
                     stringProp
                  />
                  <RadioLabelCol
                     groupNameProp={"laborPercentGroup"}
                     valueProp={75}
                     onChangeProp={"laborPct"}
                     displayProp={"75"}
                     stringProp
                  />
                  <RadioLabelCol
                     groupNameProp={"laborPercentGroup"}
                     valueProp={100}
                     onChangeProp={"laborPct"}
                     displayProp={"100"}
                     stringProp
                  />
               </RadioButtonRow>
               <InputRangeRow
                  titleProp={"Std. Spindle Count"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={1}
                  maxProp={999}
                  propertyNameProp={"stdSpindleCount"}
                  errorDialogueProp={"1-999 only"}
                  floatProp={false}
               />
            </Col>
            <Col>
               <ProgramNameRow
                  ColPromptSizeProp={6}
                  ColValueSizeProp={6}
                  valueProp="program"
                  titleProp="Program"
               />
               <RunTimeRow
                  TitleProp="#3 Min"
                  ValueProp="minTime3"
                  ColPromptSizeProp={6}
                  ColValueSizeProp={6}
               />
               <InputRangeRow
                  titleProp={"#3 Mbar"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={0}
                  maxProp={999}
                  propertyNameProp={"mBar3"}
                  errorDialogueProp={"0-999 only"}
                  floatProp={false}
               />
               <InputRangeRow
                  titleProp={"#3 °C"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={0.0}
                  maxProp={99.9}
                  propertyNameProp={"celsius3"}
                  errorDialogueProp={"0.0-99.9 only"}
                  floatProp={true}
               />
               <InputRangeRow
                  titleProp={"#3 °C/min"}
                  descriptionProp={""}
                  sizeProp={6}
                  colSizeProp={6}
                  typeProp={"text"}
                  minProp={0.0}
                  maxProp={9.9}
                  propertyNameProp={"celsiusMin3"}
                  errorDialogueProp={"0.0-9.9 only"}
                  floatProp={true}
               />
            </Col>
         </Row>
         <Row className="mb-2">
            <ColPrompt title={"Special Instructions"} bold={true} />
         </Row>
         <Row>
            <Col xxl={{ offset: 1, size: 6 }}>
               <Input
                  type="textarea"
                  className="serviceThreadTextArea"
                  style={{ borderRadius: "10px", fontSize: "14px", minHeight: "10vh", }}
                  value={machineSetup.instructions || ""}
                  onChange={(e) => onChange("instructions", e.target.value)}
               />
            </Col>
         </Row>
      </>
   );
}
